<template>
  <main id="app">
    <Header v-show="hasHeader" :isSticky="headerIsSticky" />
    <router-view />
    <EnterpriseWeChat />
    <Footer v-show="hasFooter" />
  </main>
</template>

<script>
import Header from "@components/header";
import Footer from "@components/footer";
import EnterpriseWeChat from "@components/EnterpriseWeChat";
import { mapState, mapMutations } from 'vuex'; // 引入 Vuex 辅助函数

export default {
  name: "App",
  components: {
    Header,
    Footer,
    EnterpriseWeChat,
  },
  data() {
    return {
      // 页面布局控制
      hasHeader: true,
      headerIsSticky: false,
      hasFooter: true,
      // 事件句柄（用于移除监听）
      handleKeydown: null,
      handleContextMenu: null,
    };
  },
  computed: {
    // 从 Vuex state 中映射 userInfo
    ...mapState(['userInfo']),
    // 或者使用 getters
    // ...mapGetters(['getUserInfo']),
  },
  watch: {
    // userInfo监听函数：当用户登录、登出时自动开启或关闭控制台防护
    userInfo: {
      handler(newVal) {
        this.toggleProtection(newVal);
      },
      immediate: true,
    },
  },
  beforeCreate() {
    // 从缓存（localStorage）读取用户信息，直接提交到 Vuex
    const info = localStorage.getItem('userInfo');
    if (info) {
      try {
        const userInfo = JSON.parse(info);
        // 直接通过 $store.commit 提交，不依赖 methods
        this.$store.commit('setUserInfo', userInfo);
      } catch (e) {
        // 解析失败则忽略
        console.warn('解析 userInfo 缓存失败', e);
      }
    }
  },
  created() {
    // 路由全局前置守卫
    this.$router.beforeResolve((to, from, next) => {
      this.test();

      // 合并路由 meta 中的布局配置
      const defaultMeta = {
        hasHeader: true,
        headerIsSticky: false,
        hasFooter: true,
      };
      const meta = { ...defaultMeta, ...to.meta };
      Object.keys(meta).forEach((v) => {
        this[v] = meta[v];
      });

      // 登录校验
      const { disableCheckUser } = to.meta;
      if (disableCheckUser === undefined) {
        // 直接从 Vuex 读取 userInfo
        const userInfo = this.userInfo;
        if (userInfo === null || "token" in userInfo === false) {
          const { name, query, params, path } = to;
          const data = { name, query, params, path };
          next({ name: "login", params: data });
          return;
        }
      }
      next();
    });
  },
  beforeDestroy() {
    this.disableProtection();
  },
  methods: {
    // 从 Vuex 映射 mutations
    ...mapMutations(['setUserInfo', 'clearUserInfo']),

    // 从缓存读取用户信息
    getUserInfoFromCache() {
      // 根据你实际用的缓存方式（localStorage / sessionStorage / cookie）
      const info = localStorage.getItem('userInfo');
      if (info) {
        try {
          return JSON.parse(info);
        } catch {
          return null;
        }
      }
      return null;
    },

    // toggleProtection函数：根据用户信息切换防护状态
    toggleProtection(userInfo) {
      const shouldProtect = !userInfo;
      if (shouldProtect) {
        this.enableProtection();
      } else {
        this.disableProtection();
      }
    },

    // enableProtection函数：启用调试防护
    enableProtection() {
      this.disableProtection();

      this.handleKeydown = (e) => {
        const isF12 = e.keyCode === 123;
        const isCtrlShiftI = e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74);
        const isCtrlU = e.ctrlKey && e.keyCode === 85;
        const isCmdOptI = e.metaKey && e.altKey && e.keyCode === 73;

        if (isF12 || isCtrlShiftI || isCtrlU || isCmdOptI) {
          e.preventDefault();
        }
      };

      this.handleContextMenu = (e) => {
        e.preventDefault();
      };

      document.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('contextmenu', this.handleContextMenu);
    },

    // disableProtection函数：关闭调试防护
    disableProtection() {
      if (this.handleKeydown) {
        document.removeEventListener('keydown', this.handleKeydown);
        this.handleKeydown = null;
      }
      if (this.handleContextMenu) {
        document.removeEventListener('contextmenu', this.handleContextMenu);
        this.handleContextMenu = null;
      }
    },
  },
};
</script>

<style>
#app main {
  box-sizing: border-box;
}

@media only screen and (max-width: 3840px) {
  #app>main {
    width: 1200px;
    margin: 0 auto;
  }
}

@media only screen and (max-width: 1024px) {
  #app>main {
    width: 768px;
    padding: 0 2%;
  }
}

@media only screen and (max-width: 768px) {
  #app>main {
    width: 100%;
  }
}
</style>